import React, { useEffect } from 'react';
import { StyledCreateWorkflowModal } from './CreateWorkflowModal.style';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import Form from '../../Form/Form';
import Field from '../../Field';
import Toast from '../../Toast';
import { useForm } from '../../Form';
import Button from '../../Button';
import workflowService from '../../../services/workflowService';
import { useNavigate } from 'react-router-dom';

const CreateWorkflowModal = ({ onClose, isEdit }) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async e => {
      if (isEdit) {
        const editPayload = {
          ...e,
          workflow_id: isEdit?.workflow_id,
        };
        return await workflowService.updateWorkflow(editPayload);
      } else {
        const res = await workflowService.createWorkflow({
          ...e,
          steps: [],
        });
        navigate(`/workflows/${res?.id}`);
        return res;
      }
    },
    onSuccess: response => {
      Toast({
        type: 'success',
        message: response.detail,
      });
      queryClient.invalidateQueries({ queryKey: ['get_all_workflows'] });
      onClose();
    },
    onError: err => {
      Toast({
        type: 'error',
        message: err.detail,
      });
    },
  });

  const handleSubmit = async e => {
    mutation.mutate(e);
  };

  const [form] = useForm();

  useEffect(() => {
    if (isEdit) {
      form.setFieldsValue({
        name: isEdit?.name,
        description: isEdit?.description,
      });
    }
  }, []);

  return (
    <StyledCreateWorkflowModal>
      <div className="content-box">
        <Form form={form} onSubmit={handleSubmit}>
          <div className="input-holder">
            <Form.Item
              label="Name"
              type="text"
              rounded
              name="name"
              placeholder="Example: Quarterly Planning & Research"
              rules={[
                {
                  required: true,
                  message: 'Name is Required',
                },
              ]}>
              <Field />
            </Form.Item>
            <Form.Item
              label="Description"
              type="textarea"
              rounded
              name="description"
              placeholder="This workflow is a collection of threads related to planning..."
              rules={[
                {
                  required: true,
                  message: 'Description is Required',
                },
              ]}>
              <Field />
            </Form.Item>
          </div>
          <div className="btn-holder">
            <Button width="170px" variant="secondary-outline" onClick={() => onClose()}>
              Cancel
            </Button>
            <Button width="170px" disabled={mutation?.isPending} loader={mutation?.isPending}>
              {isEdit ? 'Edit Workflow' : 'Create Workflow'}
            </Button>
          </div>
        </Form>
      </div>
    </StyledCreateWorkflowModal>
  );
};

export default CreateWorkflowModal;
